<template>
  <div class="LimeSurvey">
    <v-container fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex xs12 md10>
          <v-card v-if="loading">
            <v-card-text
              class="text-xs-center"
            >
              <v-progress-circular
                class="text-xs-center"
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>
          </v-card>

          <v-card v-else>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-autocomplete
                    :items="polls"
                    item-value="id"
                    item-text="title"
                    label="Encuestas Lime Survey"
                    v-model="poll"
                    auto-select-first
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12>
                  <v-autocomplete
                    :items="operativos"
                    item-value="id"
                    item-text="nombre_operativo"
                    label="Todos Operativos iKontrol"
                    v-model="oper"
                    auto-select-first
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!poll || !oper"
                color="info"
                @click="openDialog(poll, oper)"
              >
                Configurar
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card>
            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text>
              <v-data-table
                dense
                :headers="headers"
                :items="configs"
                :search="search"
                no-results-text="No se encontraron configuraciones activas"
                no-data-text="No hay datos disponibles"
                multi-sort
                disable-initial-sort
                class="elevation-1"
                loading="Cargando... Por favor espere."
                :key="tableKey"
              >
                <template v-slot:items="props">
                  <td>
                    {{ pollsNames[props.item.ls] }}
                  </td>
                  <td>
                    {{ operNames[props.item.operativo] }}
                  </td>
                  <td>
                    <v-layout align-center justify-space-around>
                      <v-icon
                        color="error"
                        @click="openDialog(props.item.ls, null)"
                      >
                        cancel
                      </v-icon>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog
        v-model="dialog"
        persistent
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            <span v-if="sendOper"
              class="headline"
            >
              Crear Configuración
            </span>
            <span v-else
              class="headline"
            >
              Eliminar Configuración
            </span>
          </v-card-title>

          <v-card-text v-if="sendOper">
            Seguro que quiere realizar una configuración entre:

            <v-card-text>
              <span class="title">Encuesta:</span> <br>
              {{ pollsNames[poll] }} <br>
              <span class="title">Operativo:</span> <br>
              {{ operNames[oper] }}
            </v-card-text>
          </v-card-text>

          <v-card-text v-if="sendOper">
            <span class="title">Esta acción eliminará cualquier configuración previa y no se podrá recuperar.</span>
            <v-checkbox
              v-model="checkbox"
              label="Confirmo que deseo realizar esta configuración"
            ></v-checkbox>
          </v-card-text>

          <v-card-text v-else>
            <span class="title">Esta acción eliminará esta configuración y no se podrá recuperar.</span>
            <v-checkbox
              v-model="checkbox"
              label="Confirmo que deseo realizar esta configuración"
            ></v-checkbox>
          </v-card-text>

          <v-alert :value="alert" type="error">
            No se ha podido realizar la operación.
          </v-alert>

          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="info"
              :disabled="loading"
              @click="closeDialog()"
            >
              Cancelar
            </v-btn>
            <v-btn
              :color="sendOper ? 'success' : 'error'"
              @click="configure(sendPoll, sendOper)"
              :disabled="!checkbox || loading"
              v-text="sendOper ? 'Salvar' : 'Eliminar'"
            ></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </div>
</template>

<script>

export default {
  name: `LimeSurvey`,

  components: {
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.getPolls('list')
    this.getPolls('config')
    this.getOperation()
  },

  data: function () {
    return {
      backConf: {
        path: '/briefcase/ls',
        pathList: '/core/operational/?page=',
        page: 1
      },

      dialog: false,
      checkbox: false,
      alert: false,

      polls: [],
      operativos: [],
      configs: null,

      loading: false,
      progressSize: 70,
      progressWidth: 7,

      poll: null,
      oper: null,
      sendPoll: null,
      sendOper: null,

      headers: [
        {
          text: 'Lime Survey',
          value: 'ls',
          align: 'left'
        },
        { text: 'Operativo', value: 'operativo', align: 'left' },
        { text: 'Acciones', value: '', align: 'center', sortable: false }
      ],

      tableKey: 0,
      search: '',
      pollsNames: null,
      operNames: null
    }
  },

  watch: {},

  computed: {},

  methods: {
    /**
     * Obtiene la lista de encuestas almacenadas en Lime Survey
     * @param  {string} mode list o config, listar las encuestas o ver configuraciones activas
     */
    getPolls (mode) {
      this.loading = true

      let request = {
        method: 'get',
        params: {
          mode: mode
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          if (mode === 'list') {
            t.polls = resp.data
            t.createPollsNames()
          } else {
            t.configs = resp.data
            t.tableKey += 1
          }
          t.loading = false
        })
        .catch(function (err) {
          if (mode === 'list') {
            t.polls = []
          } else {
            t.configs = null
            t.tableKey += 1
          }
          t.loading = false
          console.error(err)
        })
    },

    /**
     * Carga la información de todos los operativos
     */
    getOperation () {
      this.loading = true
      let request = {
        method: 'get',
        data: {},
        url: this.backConf.pathList + this.backConf.page
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.operativos = t.operativos.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.getOperation()
          } else {
            t.createOperNames()
            t.backConf.page = 1
            t.loading = false
          }
        })
        .catch(function (err) {
          t.operativos = []
          t.backConf.page = 1
          t.loading = false
          console.error(err)
        })

      t.tableOperationKey += 1
    },

    /**
     * Configura la extracción de encuestas desde Lime Survey
     * @param  {integer} poll id de la encuesta
     * @param  {integer} oper id del operativo
     */
    configure (poll, oper) {
      this.loading = true

      let request = {
        method: 'post',
        data: {
          survey: poll,
          operativo: oper
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.loading = false
          t.dialog = false
          t.getPolls('config')
          console.log(resp)
        })
        .catch(function (err) {
          t.loading = false
          t.alert = true
          console.error(err)
        })
    },

    /**
     * Genera un objeto para referenciar los valores de polls hacia el usuario
     */
    createPollsNames () {
      let pllName = {}
      this.polls.forEach(function (obj) {
        pllName[obj.id] = obj.title
      })
      this.pollsNames = pllName
    },

    /**
     * Genera un objeto para referenciar los valores de operativos hacia el usuario
     */
    createOperNames () {
      let opName = {}
      this.operativos.forEach(function (obj) {
        opName[obj.id] = obj.nombre_operativo
      })
      this.operNames = opName
    },

    /**
     * Abre el dialogo y setea las variables con las que funciona
     * @param  {integer} poll id de la encuesta
     * @param  {integer} oper id del operativo
     */
    openDialog (poll, oper) {
      this.dialog = true
      this.alert = false
      this.checkbox = false

      this.sendPoll = poll
      this.sendOper = oper
    },

    /**
     * Cierra el dialogo y setea las variables con las que funciona
     */
    closeDialog () {
      this.dialog = false
      this.alert = false
      this.checkbox = false
      this.sendPoll = null
      this.sendOper = null
    }

  }
}
</script>
